import React from "react";
import { Card, Col } from "react-bootstrap";
import { getFromLS } from "../../../utils/storage";
import './ComingSoon.css'

export default function ComingSoon(props) {
    const username = getFromLS("username")
    return (
        <Col className="card-container-coming-soon">
            <div className="coming-soon">
            <span className="coming-soon-header"> Hello {username.charAt(0).toUpperCase()+username.substr(1).toLowerCase()}! &nbsp; &nbsp;</span>
            <p>We are still working on this feature. This feature will be available soon. <br /> Thank you for your patience.</p>
            </div>
        </Col>
    );
}